import React, { useEffect, useState, useRef, useCallback, Fragment } from "react";
import { Card, Form, Modal } from "react-bootstrap";
import { BsArrowBarDown, BsChevronDown, BsChevronUp } from "react-icons/bs";
import Layout from "../../components/Layout";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { Link, useHistory } from "react-router-dom";
import LocationSearchInput from "../../components/LocationSearchInput";
import { callAPI } from "../../helper/apiUtils";
import { $crud } from "../../helper/CrudFactory";
import BuildingTypesDialog from "./Dialogs/BuildingTypesDialog";
import CompanyListDialog from "./Dialogs/CompanyListDialog";
import ProjectMapComponent from "./ProjectMap/ProjectMapComponent";
import _ from "lodash";
import AutoComplete from "./Partial/AutoComplete";
import { Animated } from "react-animated-css";
import { OPEN_PROJECTS, store, UPDATE_PROJECT_ACTION_FIRE } from "../../store";
import Geocode from "react-geocode";
import { withRouter } from "react-router-dom";
import { TOGGLE_DRAWER } from "../../helper/constants";
import { connect, useSelector } from "react-redux";
import { BiArrowToBottom } from "react-icons/bi";
import { convertBranchRole, convertBuildings, convertRole } from "../../helper/convertor";
import ModernToggleSwitch from "../../components/ModernToggleSwitch";
import InfoTip from "../../components/InfoTip";
import "./EditProject.css";
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_KEY;

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_KEY);
function EditProject(props) {
    const storeOpenedProjects = useSelector(state => state.openProjects);
    const isInternal = props.isInternal
    let companyId = props.location.state?.companyId
    let companyName = props.location.state?.companyId
    const pd = props.projectDetails;
    const [params, setParams] = useState(() => {
        if (pd?.id) {
            let type = pd.buildingType ? (!Array.isArray(pd.buildingType) ? pd.buildingType.split(',') : pd.buildingType) : [];
            return {
                id: pd.id,
                name: pd.name || props.name || "",
                userRole: pd.userRole || "",
                projectNo: pd.projectNo || "",
                buildingType: type,
                areaOfActivity: pd.buildingType || "",
                street: pd.street || "",
                postCode: pd.postCode || "",
                city: pd.city || "",
                country: pd.country || "",
                lat: pd.lat || "",
                long: pd.long || "",
                companyName: "",
                houseNo: pd.houseNo || "",
                isHidden: pd.isHidden != null ? pd.isHidden : true,
                full_address: pd.full_address || "",
            };
        }
        return {
            name: props.name || "",
            projectNo: "",
            buildingType: [],
            areaOfActivity: "",
            street: "",
            postCode: "",
            city: "",
            country: "",
            lat: "",
            long: "",
            companyName: "",
            houseNo: "",
            isHidden: true,
            full_address: "",
        };
    });
    const [selectedAddress, setSelectedAddress] = useState(false)
    const [loading, setLoading] = useState(false);
    const [detailsLoading, setDetailsLoading] = useState(!pd?.id);
    const [errors, setErrors] = useState({
        name: "",
        projectNo: "",
        buildingType: [],
        areaOfActivity: "",
        street: "",
        // postCode: "",
        city: "",
        country: "",
        lat: "",
        long: "",
        houseNo: "",
        full_address: ""
    });
    const [cameraModal, setCameraModal] = useState(false);
    const [street, setStreet] = useState('');
    const [house, setHouse] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [city, setCity] = useState('');
    const [pNo, setPNo] = useState('');
    const [email, setEmail] = useState('');
    const [lat, setLat] = useState();
    const [long, setLong] = useState();
    const [full_address, setFullAddress] = useState(pd?.full_address || '');
    const [countryName, setCountryName] = useState('');
    const [showDropdpownCity, setShowDropdpownCity] = useState(false)
    const [citySelected, setCitySelected] = useState([]);
    const [citySelectedAPIParam, setCitySelectedAPIParam] = useState([]);
    const [searchCity, setSearchCity] = useState('');
    const [mainVal, setMainVal] = useState(pd?.full_address || '');
    const [showOptionalInfo, setShowOptionalInfo] = useState(true)
    const [isEditingName, setIsEditingName] = useState(false)
    const [isEditingAddress, setIsEditingAddress] = useState(false)
    const [isEditingProjectNo, setIsEditingProjectNo] = useState(false)
    const nameInputRef = React.useRef(null)
    const [paramsLoaded, setParamsLoaded] = useState({
        name: false,
        buildingType: false,
        areaOfActivity: false,
        projectNo: false,
    });
    const { isGerm, strings } = React.useContext(LanguageContext);
    const [suggestionLoaded, setSuggestionLoaded] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [show, setShow] = useState(false);
    const [showCompanyDialog, setCompanyDialog] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [showOptionalInformation, setShowOptionalnformation] = useState(true)
    const [displayTypes, setDisplayTypes] = useState(() => {
        if (pd?.buildingType && Array.isArray(pd.buildingType)) {
            return pd.buildingType.map(t => convertBuildings(t.trim(), isGerm)).join(', ');
        }
        return '';
    });
    const [defultTyesArr, setDefaultsArr] = useState(pd?.buildingType || []);
    // Fall back to the role fetched by this component's own /building/one call.
    // The parent seeds projectDetails without userRole (see seedProjectDetailsFromProps),
    // so props.isAdmin can be stale/false when opened from Latest Messages / To-Do,
    // which would otherwise hide the name-edit pencil from a genuine room admin.
    const isAdmin = props.isAdmin || params.userRole === "admin"
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const getList = async () => {
        try {
            const { data } = await callAPI(`/building/all?projectType=${isInternal ? "1" : "0"}`, "", "GET");
            console.log(data);
            if (data.status) {
                // setSuggestions(!isInternal? data.buildings:props.location.state?.projects);
                setSuggestions(!isInternal ? data.buildings : []);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const setParam = (name, value) => {
        setParams((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
        setErrors((prev) => {
            return {
                ...prev,
                [name]: "",
            };
        });
    };
    const setName = (name, value) => {
        if (value) {
            setParams((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
            setErrors((prev) => {
                return {
                    ...prev,
                    [name]: "",
                };
            });
        }
    };
    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        //Firstname
        if (!params.name) {
            formIsValid = false;
            errors["name"] = strings.invalid_fiels;
        }

        // if (!params.areaOfActivity) {
        //   formIsValid = false;
        //   errors["areaOfActivity"] = strings.invalid_fiels;
        // }

        setErrors(errors);
        return formIsValid;
    };
    const history = useHistory();
    const [companies, setCompanies] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const getCompanies = async () => {
        const { data } = await callAPI(`/company/my`, {}, "GET");
        if (data.status) {
            if (data.companies.length === 1) {
                setParam("companyId", data.companies[0].id);
            } else {
                setCompanies(data.companies);
            }
        }
    };
    useEffect(() => {
        getProjectDetails();
        if (!isInternal) {
            getCompanies();
        }
        if (isAdmin) {
            getList();
        }
    }, [props.location]);
    const getProjectDetails = async () => {
        const id = props.project_id
        const { data } = await callAPI(`/building/one/${id}`, {
            id: id
        }, 'GET')

        if (data.status) {
            const suggestion = data;
            setMainVal(suggestion.full_address)
            let types = _.isArray(suggestion.buildingType) ? suggestion.buildingType.join(', ') : suggestion.buildingType
            let tps = suggestion.buildingType
            let conveted = []
            if(tps && Array.isArray(tps))
            for (let obj of tps) {
                conveted.push(convertBuildings(obj.trim(), isGerm))
            }
            setDisplayTypes(conveted ? conveted.join(', ') : types)
            let type = suggestion?.buildingType ? !Array.isArray(suggestion?.buildingType) ? suggestion?.buildingType?.split(',') : suggestion?.buildingType : []
            setDefaultsArr(suggestion.buildingType)
            setParams(prev => {
                return {
                    ...prev,
                    id: suggestion.id,
                    name: suggestion.name,
                    userRole: suggestion.userRole,
                    projectNo: suggestion.projectNo? suggestion.projectNo : "",
                    buildingType: type,
                    areaOfActivity: tps,
                    street: suggestion.street,
                    postCode: suggestion.postCode,
                    city: suggestion.city,
                    country: suggestion.country,
                    lat: suggestion.lat,
                    long: suggestion.long,
                    houseNo: suggestion.houseNo,
                    isHidden: suggestion.isHidden,
                    full_address: suggestion.full_address
                }
            })
        }
        setDetailsLoading(false);
        initialLoadRef.current = false;
    }
    const submitProject = async () => {
        setLoading(true);
        let id = props.project_id
        console.log("params--<", params)
        if(!params.buildingType){
            params.buildingType = []
        }
        if (isInternal) {
            let errors = {}
            if (!params.name) {
                errors["name"] = strings.invalid_fiels;
                setErrors(errors)
            }
            else {
                setErrors(errors)
                try {
                    const projectData = {
                        ...params,
                        "companyId": companyId,
                        "name": params.name,
                        "projectNo": params.projectNo,
                        "companyName": companyName
                    };
                    const { data } = await callAPI("/building", "", "PUT", projectData);
                    console.log(data);
                    if (!data.status) {
                        await $crud.notify({
                            type: "error",
                            message: data.message,
                        });
                    } else {
                        const updateProjects = storeOpenedProjects.map((p) => {
                            if (p.id === id) {
                                return { ...p, ...params };
                            } else {
                                return p;
                            }
                        });
                        store.dispatch({
                            type: OPEN_PROJECTS,
                            openProjects: updateProjects
                        });
                        store.dispatch({
                            type: UPDATE_PROJECT_ACTION_FIRE,
                            updateProjectActionFire: true
                        });
                        props.handleEditClose()
                    }
                } catch (e) {
                    console.log(e);
                }
                setLoading(false);
            }
        }
        else if (handleValidation()) {
            try {
                const { data } = await callAPI(`/building${params.companyId ? `?companyId=${params.companyId}` : ""}`, "", "PUT", params);
                if (!data.status) {
                    await $crud.notify({
                        type: "error",
                        message: data.message,
                    });
                } else {
                    const updateProjects = storeOpenedProjects.map((p) => {
                        if (p.id === id) {
                            return { ...p, ...params };
                        } else {
                            return p;
                        }
                    });
                    store.dispatch({
                        type: OPEN_PROJECTS,
                        openProjects: updateProjects
                    });
                    store.dispatch({
                        type: UPDATE_PROJECT_ACTION_FIRE,
                        updateProjectActionFire: true
                    });
                    props.handleEditClose()
                }
            } catch (e) {
                console.log(e);
            }
            setLoading(false);
        } else {

            console.log("errors", errors);
        }
    };

    useEffect(() => {
        if (!selectedAddress && params.street && !params.lat) {
            let fullAddress = `${params.street} ${params.city ? `, ${params.city}` : ""}`
            Geocode.fromAddress(fullAddress).then(
                (results) => {
                    const { lat, lng } = results.results[0].geometry.location;
                    let country;
                    for (var i = 0; i < results.results[0].address_components.length; i++) {
                        for (
                            var j = 0;
                            j < results.results[0].address_components[i].types.length;
                            j++
                        ) {
                            if (
                                results.results[0].address_components[i].types[j] == "country"
                            ) {
                                country = results.results[0].address_components[i]?.long_name;
                            }
                        }
                    }
                    setParam('lat', lat)
                    setParam('long', lng)
                    setParam('country', country)
                },
                (error) => {
                    console.error(error);
                }
            );
        }
    }, [params.city, params.street])

    const getSuggestion = async (suggestion) => {
        await setParams((prev) => {
            return {
                ...prev,
                name: suggestion.name ? suggestion.name : "",
                buildingType: suggestion.buildingType
                    ? _.isArray(suggestion.buildingType)
                        ? suggestion.buildingType.join(", ")
                        : suggestion.buildingType
                    : "",
                areaOfActivity: suggestion.buildingType
                    ? _.isArray(suggestion.buildingType)
                        ? suggestion.buildingType.join(", ")
                        : suggestion.buildingType
                    : "",
                street: suggestion.street,
                postCode: suggestion.postCode,
                city: suggestion.city,
                country: suggestion.country ? suggestion.country : "germany",
                lat: suggestion.lat,
                long: suggestion.long,
                houseNo: suggestion.houseNo,
            };
        });
        setParamsLoaded((prev) => {
            return {
                ...prev,
                name: !!suggestion.name,
                buildingType: !!suggestion.buildingType,
            };
        });
        setSuggestionLoaded(true);
    };

    const getBuildings = async () => {
        try {
            const { data } = await callAPI("/building/all", "", "GET");
            if (data.status) {
                setBuildings(data.buildings);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const handleHideProject = async (e) => {
        if (props.isAdmin) {
            try {
                await $crud.confirm({
                    title: "",
                    textContent: params?.isHidden ? strings.unhidden_message : strings.hide_project_popup_text,
                    options: {
                        ok: strings.confirm,
                        cancel: strings.cancel
                    }
                });
            } catch (err) {
                return;
            }
            const updatedParams = { ...params, isHidden: !params.isHidden };
            setParams(updatedParams);
            if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
            autoSave(updatedParams);
        }
    }

    const initialLoadRef = useRef(true);
    const saveTimerRef = useRef(null);

    const autoSave = useCallback(async (currentParams) => {
        if (!currentParams.name) return;
        let id = props.project_id;
        const saveParams = { ...currentParams };
        if (!saveParams.buildingType) {
            saveParams.buildingType = [];
        }
        try {
            if (isInternal) {
                const projectData = {
                    ...saveParams,
                    "companyId": companyId,
                    "name": saveParams.name,
                    "projectNo": saveParams.projectNo,
                    "companyName": companyName
                };
                const { data } = await callAPI("/building", "", "PUT", projectData);
                if (data.status) {
                    const updateProjects = storeOpenedProjects.map((p) =>
                        p.id === id ? { ...p, ...saveParams } : p
                    );
                    store.dispatch({ type: OPEN_PROJECTS, openProjects: updateProjects });
                    store.dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
                }
            } else {
                const { data } = await callAPI(`/building${saveParams.companyId ? `?companyId=${saveParams.companyId}` : ""}`, "", "PUT", saveParams);
                if (data.status) {
                    const updateProjects = storeOpenedProjects.map((p) =>
                        p.id === id ? { ...p, ...saveParams } : p
                    );
                    store.dispatch({ type: OPEN_PROJECTS, openProjects: updateProjects });
                    store.dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }, [isInternal, companyId, companyName, props.project_id, storeOpenedProjects]);

    useEffect(() => {
        if (initialLoadRef.current) {
            return;
        }
        if (saveTimerRef.current) {
            clearTimeout(saveTimerRef.current);
        }
        saveTimerRef.current = setTimeout(() => {
            autoSave(params);
        }, 800);
        return () => {
            if (saveTimerRef.current) {
                clearTimeout(saveTimerRef.current);
            }
        };
    }, [params]);


    return (
        <React.Fragment>
            <div className={props.embedded ? "edit_project_embedded edit-project edit-project--embedded" : "w-300 edit_project_main_div edit-project edit-project--panel"}>
                <div>
                    <div className="edit-project__header">
                        {!props.embedded && (
                        <span
                            className={`material-symbols-outlined material-arrow-left kj-pointer flex-shrink-0 ${isInternal ? 'internal-arrow' : ''}`}
                            onClick={() => {
                                if (isEditingName) {
                                    setIsEditingName(false);
                                } else {
                                    props.handleEditClose();
                                }
                            }}
                        >
                            keyboard_arrow_left
                        </span>
                        )}
                        {isEditingName ? (
                            <>
                                <input
                                    ref={nameInputRef}
                                    type="text"
                                    value={params.name}
                                    onChange={(e) => setParam("name", e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            setIsEditingName(false);
                                            if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                            autoSave(params);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        if (e.relatedTarget?.dataset?.confirmName) return;
                                        setIsEditingName(false);
                                        if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                        autoSave(params);
                                    }}
                                    autoFocus
                                    className={`edit-project__name-input${isInternal ? " edit-project__name-input--internal" : ""}`}
                                />
                                <span
                                    className={`material-symbols-outlined edit-project__name-confirm${isInternal ? " edit-project__name-confirm--internal" : ""}`}
                                    data-confirm-name="true"
                                    tabIndex={-1}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => {
                                        setIsEditingName(false);
                                        if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                        autoSave(params);
                                    }}
                                >
                                    check_circle
                                </span>
                            </>
                        ) : (
                            <span className="edit-project__name">
                                {params.name || props.name}
                            </span>
                        )}
                        {isAdmin && !isEditingName && (
                            <span
                                className="material-symbols-outlined edit-project__edit-icon"
                                onClick={() => setIsEditingName(true)}
                            >
                                edit
                            </span>
                        )}
                        {errors.name && (
                            <small className="pl-2 text-danger">{errors.name}</small>
                        )}
                    </div>
                    <Form
                        className="add_company_from edit-project__form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            submitProject();
                        }}
                    >
                            {
                                !isAdmin && !isInternal?
                                <Form.Group controlId="formBasicPassword" className="position-relative">
                                    {detailsLoading ? (
                                        <div className="field-shimmer" />
                                    ) : (
                                    <Form.Control
                                        value={params.projectNo}
                                        onChange={(e) => setParam("projectNo", e.target.value)}
                                        onFocus={() => setIsEditingProjectNo(true)}
                                        onBlur={() => {
                                            setIsEditingProjectNo(false);
                                            if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                            autoSave(params);
                                        }}
                                        type="text"
                                        placeholder={strings.project_No}
                                        className={`edit-project__no-input${isEditingProjectNo ? " edit-project__no-input--editing" : ""}`}
                                    />)}
                                    {isEditingProjectNo && (
                                        <span
                                            className="material-symbols-outlined edit-project__field-confirm"
                                            tabIndex={-1}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => {
                                                setIsEditingProjectNo(false);
                                                if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                                autoSave(params);
                                            }}
                                        >
                                            check_circle
                                        </span>
                                    )}
                                {errors.projectNo && (
                                    <small className="pl-2 text-danger">
                                        {errors.projectNo}
                                    </small>
                                )}
                            </Form.Group>
                            :
                            <></>
                            }
                        {!isInternal &&
                            <>
                                {/* <div className="row">
                      <div className="col-md-8 pr-1">
                        <Form.Group controlId="formBasicPassword">
                          <LocationSearchInput
                            suggestionLoaded={
                              suggestionLoaded && params.street ? true : false
                            }
                            defaultValue={params.street}
                            placeHolder={strings.street}
                            setParam={setParam}
                            setSelectedAddress={setSelectedAddress}
                          />
                          {errors.street && (
                            <small className="pl-2 text-danger">
                              {errors.street}
                            </small>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-4 pl-1">
                        <Form.Group controlId="formBasicPassword">
                          <Form.Control
                            type="text"
                            value={params.houseNo}
                            onChange={(e) => setParam("houseNo", e.target.value)}
                            placeholder={strings.house_number}
                          />
                          {errors.houseNo && (
                            <small className="pl-2 text-danger">
                              {errors.houseNo}
                            </small>
                          )}
                        </Form.Group>
                      </div>
                    </div> */}
                                {/* <div className="row">
                      <div className="col-md-5 pr-1">
                        <Form.Group controlId="formBasicPassword">
                          <Form.Control
                            value={params.postCode}
                            disabled={suggestionLoaded}
                            onChange={(e) => setParam("postCode", e.target.value)}
                            type="text"
                            placeholder={strings.postal_code}
                          />
                          {errors.postCode && (
                            <small className="pl-2 text-danger">
                              {errors.postCode}
                            </small>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-7 pl-1">
                        <Form.Group controlId="formBasicPassword">
                          <Form.Control
                            value={params.city}
                            disabled={suggestionLoaded}
                            onChange={(e) => setParam("city", e.target.value)}
                            type="text"
                            placeholder={strings.city}
                          />
                          {errors.city && (
                            <small className="pl-2 text-danger">
                              {errors.city}
                            </small>
                          )}
                        </Form.Group>
                      </div>
                    </div> */}
                            </>
                        }
                        {isInternal ?
                            <Form.Group controlId="formBasicPassword" className="position-relative">
                                {detailsLoading ? (
                                    <div className="field-shimmer" />
                                ) : (
                                <Form.Control
                                    value={params.projectNo}
                                    onChange={(e) => setParam("projectNo", e.target.value)}
                                    onFocus={() => setIsEditingProjectNo(true)}
                                    onBlur={() => {
                                        setIsEditingProjectNo(false);
                                        if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                        autoSave(params);
                                    }}
                                    type="text"
                                    placeholder={strings.project_No}
                                    className={`internal-project-input edit-project__no-input${isEditingProjectNo ? " edit-project__no-input--editing" : ""}`}
                                />)}
                                {isEditingProjectNo && (
                                    <span
                                        className="material-symbols-outlined edit-project__field-confirm edit-project__field-confirm--internal"
                                        tabIndex={-1}
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => {
                                            setIsEditingProjectNo(false);
                                            if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                            autoSave(params);
                                        }}
                                    >
                                        check_circle
                                    </span>
                                )}
                                {errors.projectNo && (
                                    <small className="pl-2 text-danger">
                                        {errors.projectNo}
                                    </small>
                                )}
                            </Form.Group>
                            :
                            <></>
                        }
                        {(!isInternal && isAdmin) &&
                            <>
                                <div className="hide-room-card-header edit-project__hide-card">
                                    <div className="project-checkbox edit-project__hide-row">
                                        <span className="edit-project__hide-label">
                                            {strings.hide_project}
                                            <InfoTip
                                                className="ml-2"
                                                title={strings.hide_project}
                                                text={params?.isHidden ? strings.unhidden_message : strings.hide_project_popup_text}
                                            />
                                        </span>
                                        <ModernToggleSwitch
                                            checked={params?.isHidden}
                                            onChange={handleHideProject}
                                            id="custom-switchx"
                                            variant={isInternal ? "green" : "orange"}
                                        />
                                    </div>
                                </div>
                            </>
                        }
                        {
                            (!isInternal && isAdmin) ?
                                <div onClick={() => {
                                    setShowOptionalnformation(!showOptionalInformation)
                                }} className="edit-project__optional-toggle">
                                    <div className="kj-flex-1">
                                        <h6 className="m-0">
                                            {strings.optional_information}
                                        </h6>
                                    </div>
                                    <div className="edit-project__chevron">
                                        {!showOptionalInformation ?
                                            <BsChevronDown
                                                size={15}
                                            />
                                            :
                                            <BsChevronUp
                                                size={15}
                                            />
                                        }
                                    </div>
                                </div>
                                :
                                <></>
                        }

                        {
                            (!isInternal && showOptionalInformation && isAdmin) ?
                                <>
                                    <Form.Group controlId="formBasicPassword11" className="edit-project__address-group"
                                        onFocus={() => setIsEditingAddress(true)}
                                        onBlur={(e) => {
                                            if (!e.currentTarget.contains(e.relatedTarget)) {
                                                setIsEditingAddress(false);
                                                if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                                autoSave(params);
                                            }
                                        }}
                                    >
                                        {detailsLoading ? (
                                            <div className="field-shimmer" />
                                        ) : (
                                        <LocationSearchInput
                                            custom
                                            defaultValue={full_address}
                                            placeHolder={strings.Address}
                                            setVal={(val) => {
                                                if (!val) {
                                                    setParam('full_address', '')
                                                }
                                                setMainVal(val)
                                                setSearchCity(val)
                                            }}
                                            val={mainVal}
                                            setFull={(val) => {
                                                setMainVal(val)
                                                setParam('full_address', val)
                                                setFullAddress(val)
                                            }}
                                            disbled={isAdmin ? false : true}
                                        />)}
                                        {isEditingAddress && (
                                            <span
                                                className={`material-symbols-outlined edit-project__field-confirm${isInternal ? " edit-project__field-confirm--internal" : ""}`}
                                                tabIndex={-1}
                                                onMouseDown={(e) => e.preventDefault()}
                                                onClick={() => {
                                                    setIsEditingAddress(false);
                                                    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                                    autoSave(params);
                                                }}
                                            >
                                                check_circle
                                            </span>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId="formBasicPassword" className="position-relative">
                                        {detailsLoading ? (
                                            <div className="field-shimmer" />
                                        ) : (
                                        <Form.Control
                                            value={params.projectNo}
                                            onChange={(e) => setParam("projectNo", e.target.value)}
                                            onFocus={() => setIsEditingProjectNo(true)}
                                            onBlur={() => {
                                                setIsEditingProjectNo(false);
                                                if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                                autoSave(params);
                                            }}
                                            type="text"
                                            placeholder={strings.project_No}
                                            className={`edit-project__no-input${isEditingProjectNo ? " edit-project__no-input--editing" : ""}`}
                                        />)}
                                        {isEditingProjectNo && (
                                            <span
                                                className={`material-symbols-outlined edit-project__field-confirm${isInternal ? " edit-project__field-confirm--internal" : ""}`}
                                                tabIndex={-1}
                                                onMouseDown={(e) => e.preventDefault()}
                                                onClick={() => {
                                                    setIsEditingProjectNo(false);
                                                    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
                                                    autoSave(params);
                                                }}
                                            >
                                                check_circle
                                            </span>
                                        )}
                                        {errors.projectNo && (
                                            <small className="pl-2 text-danger">
                                                {errors.projectNo}
                                            </small>
                                        )}
                                    </Form.Group>
                                </>
                                :
                                <></>
                        }

                    </Form>
                </div>
            </div>
            {showDialog && (
                <BuildingTypesDialog
                    ctom
                    handleClose={(e) => setShowDialog(false)}
                    setParam={setParam}
                    setTypesToDisplay={setDisplayTypes}
                    defaultBuildings={defultTyesArr}
                />
            )}

            {showCompanyDialog && (
                <CompanyListDialog
                    handleClose={(e) => setCompanyDialog(false)}
                    setParam={setParam}
                    handleReJoinCompany={() => { }}
                    companies={companies}
                />
            )}

        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    const {
        projects,
        openProjects,
        updateProjectActionFire,
        openBottomProjects,
        projectRequestCount,
        isOpenByOwner,
    } = state;
    return {
        projects: projects,
        updateProjectActionFire: updateProjectActionFire,
        openProjects: openProjects,
        openBottomProjects: openBottomProjects,
        projectRequestCount: projectRequestCount,
        isOpenByOwner: isOpenByOwner,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        handleDrawer: (open) => dispatch({ type: TOGGLE_DRAWER, open })
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditProject));
